import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        cosmic:
          "border-purple-500/30 bg-gradient-to-r from-purple-900/40 to-blue-900/40 text-white backdrop-blur-md hover:from-purple-800/50 hover:to-blue-800/50 shadow-lg shadow-purple-500/20",
        stellar:
          "border-blue-500/30 bg-gradient-to-r from-blue-900/40 to-cyan-900/40 text-white backdrop-blur-md hover:from-blue-800/50 hover:to-cyan-800/50 shadow-lg shadow-blue-500/20",
        nebula:
          "border-pink-500/30 bg-gradient-to-r from-pink-900/40 to-purple-900/40 text-white backdrop-blur-md hover:from-pink-800/50 hover:to-purple-800/50 shadow-lg shadow-pink-500/20",
        void:
          "border-gray-500/30 bg-black/50 text-white backdrop-blur-lg hover:bg-black/60 shadow-lg shadow-black/40",
        glow:
          "border-white/20 bg-white/20 text-white backdrop-blur-md hover:bg-white/30 shadow-lg shadow-white/10",
        quantum:
          "border-emerald-500/30 bg-gradient-to-r from-emerald-900/40 to-teal-900/40 text-white backdrop-blur-md hover:from-emerald-800/50 hover:to-teal-800/50 shadow-lg shadow-emerald-500/20",
        success:
          "border-green-500/30 bg-gradient-to-r from-green-900/40 to-emerald-900/40 text-white backdrop-blur-md hover:from-green-800/50 hover:to-emerald-800/50 shadow-lg shadow-green-500/20",
        warning:
          "border-yellow-500/30 bg-gradient-to-r from-yellow-900/40 to-orange-900/40 text-white backdrop-blur-md hover:from-yellow-800/50 hover:to-orange-800/50 shadow-lg shadow-yellow-500/20",
        danger:
          "border-red-500/30 bg-gradient-to-r from-red-900/40 to-pink-900/40 text-white backdrop-blur-md hover:from-red-800/50 hover:to-pink-800/50 shadow-lg shadow-red-500/20"
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }